module.exports = __webpack_public_path__ + "img/winner2.c28552c2.png";